import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const SuitCase = _ref => {
  let {
      size = 24,
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M8.125 0C7.77982 0 7.5 0.279822 7.5 0.625V3.75H5.625C4.58947 3.75 3.75 4.58947 3.75 5.625V16.875C3.75 17.693 4.27384 18.3887 5.00436 18.6448C5.00148 18.6795 5 18.7146 5 18.75C5 19.4404 5.55964 20 6.25 20C6.94036 20 7.5 19.4404 7.5 18.75H12.5C12.5 19.4404 13.0596 20 13.75 20C14.4404 20 15 19.4404 15 18.75C15 18.7146 14.9985 18.6795 14.9956 18.6448C15.7262 18.3887 16.25 17.693 16.25 16.875V5.625C16.25 4.58947 15.4105 3.75 14.375 3.75H12.5V0.625C12.5 0.279822 12.2202 0 11.875 0H8.125ZM11.25 3.75H8.75V1.25H11.25V3.75ZM5 8.75V7.5H15V8.75H5Z",
    fill: color
  }));
};
export default SuitCase;